import React, { memo } from 'react';
import { func, bool } from 'prop-types';
import { reduxForm } from 'redux-form';
import { UTButton } from '@widergy/energy-ui';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';

import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';
import { ENTITIES_LOGIN } from 'constants/reduxForms';

import styles from './styles.module.scss';
import { nameField } from './constants';

const Login = ({ handleSubmit, invalid, submitFailed }) => (
  <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit} className={styles.container}>
    <UTForm fields={[nameField]} />
    <UTButton disabled={invalid && submitFailed} type="submit" primary uppercase>
      {message('EntitiesComplaint:enter')}
    </UTButton>
  </form>
);

Login.propTypes = {
  handleSubmit: func,
  invalid: bool,
  submitFailed: bool
};

export default reduxForm({ form: ENTITIES_LOGIN })(memo(Login));
